import { SF } from '@/storefront';

    let _hashId = 0;

    const _eventsRegistered: { [event: string]: { querySelector: string, callback: (e: Event, targetEl: HTMLElement) => void | boolean }[] } = {};

    const TOUCH_DISTANCE = Math.round(screen.height / 20);  // Play with this, maybe a percantage of screen size?
    const DOUBLETAP_THRESHOLD = 300;

    const _doubleTaps: { [key: string]: {
            pointerId: number,
            Y: number;
            X: number;
            timeout: number;
        } } = {};


    function _getNodeDepth(el: Node, target: Node|null): number {
        let depth = 0;
        while (el != target && target != null) {
            depth++;
            target = target.parentNode;
        }
        return depth;
    }

    function _handleEvent(eventType: string, e: Event): void {
        _eventsRegistered[eventType].some(registeredEvent => {
            let els:HTMLElement[] = [];
            const querySelectors = registeredEvent.querySelector.split(/,/);
            querySelectors.forEach(querySelector => {
                const res = document.querySelectorAll<HTMLElement>(querySelector.trim());
                if (res.length > 0) {
                    els = els.concat(Array.from(res));
                }
            });
            const matches:{ el: HTMLElement, depth: number }[] = els.reduce((accum:{ el: HTMLElement, depth: number }[], el:HTMLElement): { el: HTMLElement, depth: number }[] => {
                if (el.contains(e.target as Node)) {
                    accum.push({el, depth: _getNodeDepth(el, e.target as HTMLElement)});
                }
                return accum;
            }, []);
            matches.sort((a, b): number => {
                return a.depth - b.depth;
            });

            return matches.some(match => {
                return registeredEvent.callback(e, match.el) === false;
            });

        });
    }

    function isMultipleTouches(event: TouchEvent):boolean {
        return (event.targetTouches || (event.target as any).touches || []).length > 1;
    }

    function isTheSameFingerId(e: PointerEvent, pointerId:number):boolean {
        return !e.pointerId || typeof pointerId === 'undefined' || e.pointerId === pointerId;
    }

    function hashTargetEl(el: any): void {
        if (!el.hashId) {
            el.hashId = 'h-' + _hashId++;
        }
    }

    function registerDblTap(querySelector: string, callback: (e: Event, targetEl: HTMLElement) => void): void {
        SF.addEventListener('touchend', querySelector, (ev:Event, targetEl:HTMLElement): void => {
            const e = ev as TouchEvent;
            hashTargetEl(targetEl);
            const lastEvent = _doubleTaps[(targetEl as any).hashId];
            const touchLocation = e.changedTouches[0] || {pageX: 0, pageY: 0};
            if (lastEvent) {
                if (isTheSameFingerId(ev as PointerEvent, lastEvent.pointerId) && !isMultipleTouches(e)) {
                    if (Math.abs(touchLocation.pageY - lastEvent.Y) < TOUCH_DISTANCE && Math.abs(touchLocation.pageX - lastEvent.X) < TOUCH_DISTANCE) {
                        callback(e, targetEl);
                    }
                }
                delete _doubleTaps[(targetEl as any).hashId];
                clearTimeout(lastEvent.timeout);
            } else {
                _doubleTaps[(targetEl as any).hashId] = {
                    pointerId: (ev as PointerEvent).pointerId,
                    Y: touchLocation.pageY,
                    X: touchLocation.pageX,
                    timeout: window.setTimeout(() => {
                        delete _doubleTaps[(targetEl as any).hashId];
                    }, DOUBLETAP_THRESHOLD)
                };

            }
        });
    }

    // TODO: These will get added to some kind of base class as a 'delegation' type)..
    SF.addEventListener = (eventType: string|string[], querySelector: string, callback: (e: Event, targetEl: HTMLElement) => void, options?:{once?: boolean, passive?: boolean}|boolean): void => {
        if (Array.isArray(eventType)) {
            eventType.forEach(event => {
               SF.addEventListener(event, querySelector, callback, options);
            });
        } else {
            if (eventType === 'dbltap') {
                registerDblTap(querySelector, callback);
            } else {
                let listenerEvent = eventType;
                if (eventType === 'focus' || eventType === 'blur') {
                    listenerEvent = eventType === 'focus' ? 'focusin' : 'focusout';
                }
                if (!_eventsRegistered[eventType]) {
                    document.addEventListener(listenerEvent, (e: Event) => {
                        _handleEvent(eventType, e);
                    }, options);
                    _eventsRegistered[eventType] = [];
                }
                _eventsRegistered[eventType].push({querySelector, callback});
            }
        }
    };

    SF.removeEventListener = (eventType: string, querySelector: string): void => {
        if (_eventsRegistered[eventType]) {
            const foundRegisteredEvent = _eventsRegistered[eventType].filter((eventRegistered: { querySelector: string, callback: (e: Event, targetEl: HTMLElement) => void | boolean }) => {
                return (eventRegistered.querySelector === querySelector);
            });

            if (foundRegisteredEvent.length > 0) {
                foundRegisteredEvent.forEach((eventRegistered: { querySelector: string, callback: (e: Event, targetEl: HTMLElement) => void | boolean }) => {
                    const foundIndex = _eventsRegistered[eventType].indexOf(eventRegistered);
                    _eventsRegistered[eventType].splice(foundIndex, 1);
                });

            }
        }

    };

    SF.onReady = (callback: () => void): void => {
        if (document.readyState != 'loading') {
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback, {once: true});
        }
    };

